<div class="content container">
  <div fxLayout="row" class="center-vertical">
    <div class="fill-space"></div>

    <div fxFlex="60%" fxFlex.gt-md="768px" fxFlex.lt-sm="90%">
      <ng-content></ng-content>
    </div>

    <div class="fill-space"></div>
  </div>
</div>
